// Beza dua teks ikut BARIS (LCS) — untuk "Show changes vs live" skrin Review Partner.
// Pulang [{ jenis: 'sama' | 'tambah' | 'buang', teks }]. Teks terlalu panjang → null
// (pemanggil papar dua teks sebelah-menyebelah; tidak pernah membeku page).
const HAD_BARIS = 2000;

export function bezaBaris(lama, baru) {
    const a = String(lama || '').split('\n');
    const b = String(baru || '').split('\n');
    if (a.length * b.length > HAD_BARIS * HAD_BARIS / 4) return null;
    const n = a.length; const m = b.length;
    const t = Array.from({ length: n + 1 }, () => new Uint16Array(m + 1));
    for (let i = n - 1; i >= 0; i--) {
        for (let j = m - 1; j >= 0; j--) {
            t[i][j] = a[i] === b[j] ? t[i + 1][j + 1] + 1 : Math.max(t[i + 1][j], t[i][j + 1]);
        }
    }
    const keluar = [];
    let i = 0; let j = 0;
    while (i < n && j < m) {
        if (a[i] === b[j]) { keluar.push({ jenis: 'sama', teks: a[i] }); i++; j++; }
        else if (t[i + 1][j] >= t[i][j + 1]) { keluar.push({ jenis: 'buang', teks: a[i] }); i++; }
        else { keluar.push({ jenis: 'tambah', teks: b[j] }); j++; }
    }
    while (i < n) keluar.push({ jenis: 'buang', teks: a[i++] });
    while (j < m) keluar.push({ jenis: 'tambah', teks: b[j++] });
    return keluar;
}
